import { useEffect, useState } from 'react';

export const useScrollDirection = () => {
  const [pageScrollDir, setPageScrollDir] = useState('down');

  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollTop = window.scrollY;
      const endOfPage = scrollTop + clientHeight >= scrollHeight;

      const hiddenNavigation = scrollTop > lastScrollTop && !endOfPage;

      if (lastScrollTop < 5) {
        setPageScrollDir('down');
      } else if (hiddenNavigation) {
        setPageScrollDir('up');
      } else {
        setPageScrollDir('down');
      }
      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return pageScrollDir;
};
